module.exports = __webpack_public_path__ + "static/media/users.dfebc356.svg";